<template>
  <div class="row">
    <div class="col-lg-2 col-md-3 private-project-border" style="max-height: 750px;overflow-y: scroll;">
      <div class="row mb-2 pb-3" style="border-bottom: 1px solid #f3f3f3" >
        <div class="input-group">
          <span class="input-group-text"><font-awesome-icon icon="filter"  style="color: #1e3e67"/></span>
          <input v-model="searchText" placeholder="Search Project" class="align-items-sm-center form-control" type="search">
        </div>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item" v-for="userProject in userProjects" :key="userProject.id"
             :style="{border: userProject.projectId == selectedProjectId ? '1px solid #56759c' : '',
                     background: userProject.projectId == selectedProjectId ? '#f2f6f9' : ''}">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed active" type="button"
                    @click="UserAssignProjects(userProject.projectId)">
              <span class="mx-2" style="font-size: 14px">{{userProject.projectName}}</span>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="col-lg-9 col-md-9 mx-lg-2">
        <div class="row dashboard-border">
          <div class="col-md-3 col-12 align-self-center" >
            <img src="../../assets/icons/projects.png" height="32" width="32"/>
            <span class="mx-2"> Private Project Users </span>
          </div>
          <div class="col-md-9 col-12 text-end align-self-center">
            <button class="btn" type="button" data-bs-toggle="modal" data-bs-target="#addUser" style="background-color: #56759c;color:#ffffff" @click="openCloseUserModal()">
              <font-awesome-icon icon="plus-circle" /><span style="color: #ffffff;font-weight: unset" class="mx-1"> Add User</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row modified-table mt-3 table-responsive">
              <table class="table table-bordered table-font table-striped table-scroll" id="DynamicTable">
                <thead>
                  <tr>
                    <th>User Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in userProject" :key="item.id"  style="cursor: pointer">
                    <td>
                      {{item.userName}}
                    </td>
                    <td>
                      <font-awesome-icon @click="TryDeleteUser(item.idUser,item.idProject)"
                                         icon="trash-alt"
                                         size="lg" class="modified-color-red button-hover"
                                         style="cursor: pointer"
                                         title="Add role this user"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12" v-if="userProject.length < 1" style="text-align: center">
                <p style="font-size: 18px;">No results found!</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    <add-user :projectId='selectedProjectId' :isActiveUserModal='isActiveUserModal'
                   @openCloseUserModal="openCloseUserModal" :user-id='userProject.idUser'
    />
    <div class="col-md-2"></div>
  </div>
</template>
<script>


  import {loadingMixin} from "../../utils/mixins";
  import AddUser from "../../components/ui/AddUser";
  import {mapActions, mapState} from "vuex";

  export default {
    name: "UserProject",
    mixins: [loadingMixin],
    components: {
      AddUser
    },
    data() {
      return {
        gridconfig: [
          {fieldName: 'userName', fieldTitle: 'User Name', type: 'text', icon: '', format: ''},
        ],
        gridMainConfig: {
          pagination: false, sorting: false
        },
        userForm: {
          userId:0,
          projectId: 0
        },
        //selectedProjectId: this.$route.params.selectedProjectId,
        selectedProjectId: 0,
        isActiveUserModal: false,
        searchText:""
      }
    },

    methods: {
      ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
      ...mapActions('users', ['getUsers']),

      UserAssignProjects(id) {
        this.selectedProjectId = id;
        console.log(this.getUserProject(this.selectedProjectId))
        this.getUserProject(this.selectedProjectId)
      },
      openCloseUserModal() {
        this.isActiveUserModal = !this.isActiveUserModal;
        //this.selectedUsers = [];
      },

       TryDeleteUser(idUser, idProject) {
         this.$swal({
          title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to delete role "' + idProject + '"  . Are you sure?</p>',
          html: "",
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#ec2929d4',
          confirmButtonColor: '#1e3e67',
          confirmButtonText: 'Yes',
        }).then(async (response) => {
          if (response.value) {
            try {
              this.userForm.userId= idUser;
              this.userForm.projectId = idProject;
               await this.deleteUser({userId:this.userForm.userId, projectId:this.userForm.projectId});
              this.$notify({
                title: "Success",
                text: "User deleted successfully. ",
                type: "success"
              });

            } catch (e) {
              this.$notify({
                title: "Error",
                text: "Failed to delete user.." + e.message,
                type: "error"
              });
            }
          }
        });
      },



    },

    computed: {
      ...mapState('projects', ['projects', 'project', 'userProject', 'isActiveProjectModal']),
      ...mapState('users', ['userList']),

      userProjects: function () {
        return this.projects.filter((post) => {
          return post.projectName.toUpperCase().match(this.searchText.toUpperCase()) && post.isPrivate == true;
        });
      },
      /*
      userProjectListe: function () {
        return this.userProject;
      },*/
    },

    async created() {
      this.showLoading();
      try {
        await this.getProjects();
      } finally {
        this.hideLoading();
      }
    },
  }
</script>


<style scoped>

.private-project-border{
  padding:12px;
  box-shadow: 0px 3px 10px #ced4da;
  cursor: pointer;
}

  ul {
    list-style-type: none;
    padding: 0;
  }
   ul li {
    text-align: center;
    font-size: 16px;
    overflow: hidden;
  }
  .accordion-item{
    margin-bottom: 5px;
  }
  .accordion-button{
    height: 63px;
  }
  .accordion-item:not(:first-of-type) {
    border: 1px solid #dee2e6;
  }
  .accordion-button:focus {
    box-shadow: unset;
  }
  .accordion-button:not(.collapsed)::before {
    background-image: var(--bs-accordion-btn-active-icon);
    transform: rotate(-180deg);;
  }
  .accordion-button:not(.collapsed){
    background-color: unset;
    color: #56759c;
    box-shadow: inset 0 calc(-1 * 1px) 0 #dee2e6;
  }
  .accordion-button::before {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform 0.2s ease-in-out;
  }
  .accordion-button::after {
    display: none;
  }
</style>
